
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faChevronDown, faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons';


interface Props {
  title: string;
  checked?: boolean;
  isInvalid?: boolean;
  icon?: React.ReactNode;
  onClick?: () => void;
}


export const ImportantInfoHeader = (props: Props) => {
  const children = (
    <>
      <div className="mr-auto">{props.title}</div>
      <div>
        {props.isInvalid ? (
          <FontAwesomeIcon icon={faExclamationTriangle} className="ml-2 text-warning" />
        ) : (props.checked ? 
          <FontAwesomeIcon icon={faCheckCircle} className="ml-2 text-success" />
          :
            props.onClick && <FontAwesomeIcon icon={faChevronDown} className="ml-2" />
        )}
      </div>
    </>
  )
  if (props.onClick) {
    return <button className="btn btn-link d-flex p-3 font-weight-bold w-100 text-left" onClick={props.onClick}>{children}</button>
  }
  else {
    return <div className="d-flex p-3 text-muted font-weight-bold">{children}</div>
  }

}